import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { get } from "lodash";
import "../../../style/react-tabs-filters.css";
import styled from "styled-components/macro";

import RemoveFilterIcon from "../../../icons/clearIconWhite.png";
import { SET_ITEM_FILTER } from "../../../store/actions/filterAction";
import { getGuiTranslations, getItemFilter, getLanguage } from "../../../store/sagas/selectors";
import CustomScrollbar from "../../CustomScrollbar/CustomScrollbar";

interface TabProps {
    showMore?: Boolean;
    addPadding?: Boolean;
}

const StyledTabPanel = styled.div<TabProps>`
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    justify-content: flex-start;
    max-width: 100%;
    overflow: hidden;
    width: calc(100% - 18px);
    transition: all 0.2s ease-in-out;

    padding-top: ${props => (props.showMore || props.addPadding ? `10px` : `0px`)};
    ${props => (props.showMore ? `min-height: 29px` : `min-height:0px`)};
    ${props => (props.showMore ? `transition-delay: 0` : `transition-delay: 0.15s`)};
`;

const FilterValueContainer = styled.div`
    display: flex;
    flex-flow: row wrap;
    margin: 3px 0px;
    justify-content: center;
    align-items: center;
`;

const FilterValueLabel = styled.label`
    padding: 4px 0px;
    cursor: pointer;
`;

const FilterValueName = styled.span`
    margin: 5px;
    border-radius: 50px;
    padding: 4px 10px;
    background-color: ${({ theme }) => get(theme, "filter.chips.backgroundColor", "#223861")};
    color: #fff;
    transition: background-color 0.2s ease-in-out;
    @media (hover) {
        &:hover {
            background-color: ${({ theme }) => get(theme, "buttonBack.hoverColor", "#223861")};
        }
    }
`;

const FilterValueCheckbox = styled.input`
    display: none;
    &:checked + ${FilterValueName} {
        background-color: ${({ theme }) => get(theme, "filter.chips.backgroundColor", "#223861")};
        color: #fff;
        &:hover {
            background-color: ${({ theme }) => get(theme, "buttonBack.hoverColor", "#223861")};
        }
    }
`;

const ChipPanel = styled.div`
    width: 100%;
    font-size: 13px;
    ${({ theme }) =>
        theme.bp.xxxl`
                    font-size: 1em;
                `}
`;

const MenuFilterIcon = styled.img`
    color: ${props => props.theme.textColorSecondary};
    height: 12px;
    margin-bottom: -1px;
    &:hover {
        background-color: rgba(254, 254, 254, 0.2);
        border-radius: 25px;
    }
`;

// TODO: Add clear filters button
export const MenuChips = ({ shouldShowFilter }: { shouldShowFilter: boolean }) => {
    const dispatch = useDispatch();
    const guiTranslations = useSelector(getGuiTranslations);
    const itemFilter = useSelector(getItemFilter);
    const language = useSelector(getLanguage);

    const handleFilterCheckedChange = (key: string, value: string, checked: boolean) => {
        const newItemFilter = itemFilter.clone();
        newItemFilter.setTag(key, value, !checked);
        dispatch({ type: SET_ITEM_FILTER, itemFilter: newItemFilter });
    };

    const activeFilterValues = itemFilter.combinedFilterValues();
    activeFilterValues.sort((a, b) => a.value.localeCompare(b.value, language || "en", { sensitivity: "base" }));
    // Height will animated if setting this to true when having any active filter values.
    const showMore = shouldShowFilter;
    const addPaddingTop = activeFilterValues.length > 0;
    return (
        <ChipPanel>
            <CustomScrollbar maxHeight="190px" renderRelative>
                <StyledTabPanel showMore={showMore} addPadding={addPaddingTop}>
                    {activeFilterValues.map(v => (
                        <FilterValueContainer key={`${v.key},${v.value}`}>
                            <FilterValueLabel>
                                <FilterValueCheckbox
                                    title={v.value}
                                    checked={itemFilter.hasTagValue("key", v.value)}
                                    type="checkbox"
                                    onChange={e => handleFilterCheckedChange(v.key, v.value, e.target.checked)}
                                />
                                <FilterValueName>
                                    {guiTranslations.get(v.value)} <MenuFilterIcon src={RemoveFilterIcon} />
                                </FilterValueName>
                            </FilterValueLabel>
                        </FilterValueContainer>
                    ))}
                </StyledTabPanel>
            </CustomScrollbar>
        </ChipPanel>
    );
};
